/* eslint-disable import/no-default-export */
import {
  DEPLOYMENTS_REQUEST,
  DEPLOYMENTS_SUCCESS,
  DeploymentsRequestAction,
  DeploymentsSuccessAction,
} from 'app/gamma/src/modules/loaders/load-deployments';
import { DeploymentsResponse } from 'app/gamma/src/types/responses';
import { createReducer } from '@trello/redux';

// Action types

export interface DeploymentsState {
  loading: boolean;
  heads: DeploymentsResponse;
}

// Reducer
const initialState: DeploymentsState = {
  loading: false,
  heads: {},
};

export default createReducer(initialState, {
  [DEPLOYMENTS_REQUEST](state, { payload }: DeploymentsRequestAction) {
    return {
      loading: true,
      heads: state.heads,
    };
  },
  [DEPLOYMENTS_SUCCESS](state, { payload }: DeploymentsSuccessAction) {
    return {
      loading: false,
      heads: payload,
    };
  },
});
